/* ============================================================
* TABDROP.JS
* COMBINATION OF BOOTSTRAP SCRIPTS NEEDED TO RUN TABDROPS
*
* PT1 - bootstrap-dropdown.js - v2.3.0
*
* PT2 - bootstrap-tab.js - v2.3.0
*
* PT3 - bootstrap-tabdrop.js
*
* PT4 - Custom Initialization
*
* ============================================================ */



/* ============================================================
* PT 1
* bootstrap-dropdown.js v2.3.0
* http://twitter.github.com/bootstrap/javascript.html#dropdowns
* ============================================================ */

!function ($) {

  'use strict'; // jshint ;_;

  //  Check if specific Bootstrap method exists - if no, define dropdown below otherwise don't redefine
  var bootstrap_enabled = (typeof $().modal === 'function');

  if (!bootstrap_enabled) {
    /* DROPDOWN CLASS DEFINITION
    * ========================= */

    var toggle = '[data-toggle=dropdown]'
    , Dropdown = function (element) {
      var $el = $(element).on('click.dropdown.data-api', this.toggle);
      $('html').on('click.dropdown.data-api', function () {
        $el.parent().removeClass('open');
      });
    };

    Dropdown.prototype = {

      constructor: Dropdown

      , toggle: function (e) {
        var $this = $(this)
        , $parent
        , isActive;

        if ($this.is('.disabled, :disabled') || !$this.parent().hasClass('tabdrop')) { return; }

        $parent = getParent($this);

        isActive = $parent.hasClass('open');

        clearMenus();

        if (!isActive) {
          $parent.toggleClass('open');
        }

        $this.focus();

        return false;
      }

      , keydown: function (e) {
        var $this
        , $items
        , $active
        , $parent
        , isActive
        , index;

        if (!/(38|40|27)/.test(e.keyCode)) { return; }

        $this = $(this);

        e.preventDefault();
        e.stopPropagation();

        if ($this.is('.disabled, :disabled')) { return; }

        $parent = getParent($this);

        isActive = $parent.hasClass('open');

        if (!isActive || (isActive && e.keyCode === 27)) {
          if (e.which === 27) { $parent.find(toggle).focus(); }
          return $this.click();
        }

        $items = $('[role=menu] li:not(.divider):visible a', $parent);

        if (!$items.length) { return; }

        index = $items.index($items.filter(':focus'));

        if (e.keyCode === 38 && index > 0) { index--; }                                        // up
        if (e.keyCode === 40 && index < $items.length - 1) { index++; }                        // down
        if (!~index) { index = 0; }

        $items
        .eq(index)
        .focus();
      }

    };

    function clearMenus() {
      $(toggle).each(function () {
        getParent($(this)).removeClass('open');
      });
    }

    function getParent($this) {
      var selector = $this.attr('data-target')
      , $parent;

      if (!selector) {
        selector = $this.attr('href');
        selector = selector && /#/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
      }

      $parent = selector && $(selector);

      if (!$parent || !$parent.length) { $parent = $this.parent(); }

      return $parent;
    }


    /* DROPDOWN PLUGIN DEFINITION
    * ========================== */

    var old = $.fn.dropdown;

    $.fn.dropdown = function (option) {
      return this.each(function () {
        var $this = $(this)
        , data = $this.data('dropdown');
        if (!data) { $this.data('dropdown', (data = new Dropdown(this))); }
        if (typeof option === 'string') { data[option].call($this); }
      });
    };

    $.fn.dropdown.Constructor = Dropdown;


    /* DROPDOWN NO CONFLICT
    * ==================== */

    $.fn.dropdown.noConflict = function () {
      $.fn.dropdown = old;
      return this;
    };


    /* APPLY TO STANDARD DROPDOWN ELEMENTS
    * =================================== */

    $(document)
    .on('click.dropdown.data-api', clearMenus)
    .on('click.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation(); })
    .on('.dropdown-menu', function (e) { e.stopPropagation(); })
    .on('click.dropdown.data-api'  , toggle, Dropdown.prototype.toggle)
    .on('keydown.dropdown.data-api', toggle + ', [role=menu]' , Dropdown.prototype.keydown);
  }

}(window.jQuery);



/* ========================================================
* PT 2
* bootstrap-tab.js v2.3.0
* http://twitter.github.com/bootstrap/javascript.html#tabs
* ======================================================== */


!function ($) {

  'use strict'; // jshint ;_;


  /* TAB CLASS DEFINITION
  * ==================== */

  var Tab = function (element) {
    this.element = $(element);
  };

  Tab.prototype = {

    constructor: Tab

    , show: function () {
      var $this = this.element
      , $ul = $this.closest('ul:not(.dropdown-menu)')
      , selector = $this.attr('data-target')
      , previous
      , $target
      , e;

      if (!selector) {
        selector = $this.attr('href');
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
      }

      if ( $this.parent('li').hasClass('active') ) { return; }

      previous = $ul.find('.active:last a')[0];

      e = $.Event('show', {
        relatedTarget: previous
      });

      $this.trigger(e);

      if (e.isDefaultPrevented()) { return; }

      $target = $(selector);

      this.activate($this.parent('li'), $ul);
      this.activate($target, $target.parent(), function () {
        $this.trigger({
          type: 'shown'
          , relatedTarget: previous
        });
      });
    }

    , activate: function ( element, container, callback) {
      var $active = container.find('> .active')
      , transition = callback
      && $.support.transition
      && $active.hasClass('fade');

      function next() {
        $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
        .removeClass('active');

        element.addClass('active');

        if (transition) {
          element[0].offsetWidth; // reflow for transition
          element.addClass('in');
        } else {
          element.removeClass('fade');
        }

        if ( element.parent('.dropdown-menu') ) {
          element.closest('li.dropdown').addClass('active');
        }

        callback && callback();
      }

      transition ?
      $active.one($.support.transition.end, next) :
      next();

      $active.removeClass('in');
    }
  };


  /* TAB PLUGIN DEFINITION
  * ===================== */

  var old = $.fn.tab;

  $.fn.tab = function ( option ) {
    return this.each(function () {
      var $this = $(this)
      , data = $this.data('tab');
      if (!data) { $this.data('tab', (data = new Tab(this))); }
      if (typeof option === 'string') { data[option](); }
    });
  };

  $.fn.tab.Constructor = Tab;


  /* TAB NO CONFLICT
  * =============== */

  $.fn.tab.noConflict = function () {
    $.fn.tab = old;
    return this;
  };

  /* TAB DATA-API
  * ============ */

  $(document).on('click.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
    e.preventDefault();
    $(this).tab('show');
  });

}(window.jQuery);

/* =========================================================
* PT 3
* bootstrap-tabdrop.js
* ========================================================= */

!function($) {
  var WinReszier = (function(){
    var registered = [];
    var inited = false;
    var timer;
    var resize = function() {
      clearTimeout(timer);
      timer = setTimeout(notify, 100);
    };
    var notify = function() {
      for(var i = 0, cnt = registered.length; i < cnt; i++) {
        registered[i].apply();
      }
    };
    return {
      register: function(fn) {
        registered.push(fn);
        if (inited === false) {
          $(window).bind('resize', resize);
          inited = true;
        }
      },
      unregister: function(fn) {
        for(var i = 0, cnt = registered.length; i < cnt; i++) {
          if (registered[i] === fn) {
            delete registered[i];
            break;
          }
        }
      }
    };
  }());

  var TabDrop = function(element, options) {
    this.element = $(element);
    this.dropdown = $('<li class="dropdown hide pull-right tabdrop"><a class="dropdown-toggle" data-toggle="dropdown" href="#">'+options.text+' <b class="caret"></b></a><ul class="dropdown-menu"></ul></li>').prependTo(this.element);
    //this.dropdown = $('<li class="dropdown hide pull-right tabdrop"><a class="dropdown-toggle" data-toggle="dropdown" href="#">'+options.text+' <b class="caret"></b></a><ul class="dropdown-menu"></ul></li>').appendTo($(this.element));
    if (this.element.parent().is('.tabs-below')) {
      this.dropdown.addClass('dropup');
    }
    WinReszier.register($.proxy(this.layout, this));
    this.layout();
  };

  TabDrop.prototype = {
    constructor: TabDrop,

    layout: function() {
      var collection = [];
      this.dropdown.removeClass('hide');
      this.element
      .append(this.dropdown.find('li'))
      .find('>li')
      .not('.tabdrop')
      .each(function(){
        if(this.offsetTop > 0) {
          collection.push(this);
        }
      });
      if (collection.length > 0) {
        collection = $(collection);
        this.dropdown
        .find('ul')
        .empty()
        .append(collection);
        if (this.dropdown.find('.active').length === 1) {
          this.dropdown.addClass('active');
        } else {
          this.dropdown.removeClass('active');
        }
      } else {
        this.dropdown.addClass('hide');
      }
    }
  };

  $.fn.tabdrop = function ( option ) {
    return this.each(function () {
      var $this = $(this),
      data = $this.data('tabdrop'),
      options = typeof option === 'object' && option;
      if (!data)  {
        $this.data('tabdrop', (data = new TabDrop(this, $.extend({}, $.fn.tabdrop.defaults,options))));
      }
      if (typeof option === 'string') {
        data[option]();
      }
    });
  };

  $.fn.tabdrop.defaults = {
    text: '<span class="icon-align-justify" aria-hidden="true"></span><span class="ic-sr-only">' + (iCreateObject.lang === 'fr' ? 'Plus' : 'More') +'</span>'
  };

  $.fn.tabdrop.Constructor = TabDrop;

}(window.jQuery);

/* =========================================================
* PT 4
* Custom Initialization
* ========================================================= */

jQuery(document).ready(function($){
  // Initialize
  $('.nav-tabs').tabdrop();

  // Inject tab headings for print
  var itemNumber;
  $('.tabDropContainer').each(function(){
    $(this).find('.nav-tabs .nav-item:first a').tab('show');
    $(this).css('opacity', '1');

    // Visible Tabs
    $(this).find('.nav-item a').each(function(){
      itemNumber = $(this).parent('.nav-item').index() + 1;
      $('<h3 class=\'printTitle\'>' + $(this).text() + '</h3>').prependTo($(this).parent('li.nav-item').parent('ul.nav-tabs').next('.tab-content').find('.tab-pane:nth-child(' + itemNumber + ')'));
    });

    // Collapsed Tabs
    itemNumber++;
    $(this).find('.nav-tabs').find('li.dropdown.tabdrop').find('ul').find('li.nav-item').find('a').each(function(){
      itemNumber++;
      $('<h3 class=\'printTitle\'>' + $(this).text() + '</h3>').prependTo($(this).parent('li.nav-item').parent('.dropdown-menu').parent('li.dropdown.tabdrop').parent('ul.nav-tabs').next('.tab-content').find('.tab-pane:nth-child(' + itemNumber + ')'));
    });


  });
  triggerResizeEvent();
});
